/**
 * useEffectで、初回レンダリング時のみ処理をスキップしたい時用。
 * useEffectと同様に以下のように使用する。
 *
 * useDidMountEffect(() => {
 *   // 二回目以降のレンダリングで行う処理。
 * }, [トリガーとなるstate]);
 */
import { useEffect, useRef } from 'react';

const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export default useDidMountEffect;
